
/**
 * Updates a setting on the backend.
 * @param {string} API_BASE 
 * @param {string} token 
 * @param {Object} setting { key: string, value: string, code_etablissement: string }
 */
async function updateSettings(API_BASE, token, setting) {
    const headers = {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${API_BASE}/settings`, {
        method: "POST", // Using POST for upsert or update if backend supports it
        headers,
        body: JSON.stringify(setting),
    });

    if (!response.ok) {
        throw new Error("Erreur lors de la mise à jour des paramètres: " + (await response.text()));
    }

    return await response.json();
}

export default updateSettings;
